<template>
  <EntityList
    :config="config"
    :columns="columns"
    :form-fields="formFields"
    authority="General_Post_Category"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'

import storeModule from '../postCategoryStoreModule'

export default {
  components: {
    EntityList,
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'post-categories',
        endpoint: 'post-categories',
        route: 'post-categories',
        title: {
          single: this.$i18n.t('Post Category'),
          plural: this.$i18n.t('Post Categories'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formFields() {
      return [
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
        },
      ]
    },
  },
}
</script>
